import React from 'react';
import { Link } from 'react-router-dom';
import AccountButton from '../AccountButton/AccountButton';

function BurgerMenu({isBurgerMenuOpen, onClose}) {
  return (
    <div className={`burger-menu ${!isBurgerMenuOpen ? 'burger-menu_closed' : ''}`}>
      <div className='burger-menu__container'>
        <button className='burger-menu__close-button' onClick={onClose} />
        <div className='burger-menu__link'>
          <Link className='burger-menu__link_item' to='/'>
            Чат
          </Link>
          <Link className='burger-menu__link_item' to='/camera'>
            Камера
          </Link>
          <Link className='burger-menu__link_item' to='/settings'>
            Настройки
          </Link>
        </div>
        <AccountButton additionalClass={'account-button__burger-menu'} />
      </div>
    </div>
  );
}
export default BurgerMenu;
